import React, { Fragment } from "react";

import { BarChart, Bar, ResponsiveContainer, YAxis, XAxis } from "recharts";

import { Metric } from "./../Utils/Utils.js";
import Heading from "../Elements/Heading.js";

const AttributionSummary = (props) => {
  const data = props.data.data;

  const renderHeader = (section) => {
    return (
      <>
        <Heading size={5} className="mb-2">
          {section.title}
        </Heading>

        <div className="d-flex mb-2">
          <div className="mr-2">
            <Metric size="lg" type={section.type} {...section.total} />
          </div>
        </div>
      </>
    );
  };

  const renderCharts = (data, type) => {
    return (
      data.charts &&
      data.charts.map((chart, index) => {
        return (
          <Fragment key={index}>
            <div className="d-flex flex-row align-items-center">
              <span className="trend__label text-capitalize mr-1 ml-0 text-muted">
                {chart.name}
              </span>
              <Metric size="xs" type={type} value={chart.value} />
            </div>

            <ResponsiveContainer height={35}>
              <BarChart
                data={[data.charts[index]]}
                layout="vertical"
                width={100}
                height={15}
                margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
                barCategoryGap={0}
              >
                <defs>
                  <linearGradient
                    id="horizontalGradient"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                  >
                    <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                    <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                  </linearGradient>
                </defs>
                <XAxis type="number" hide />
                <YAxis type="category" hide />

                <Bar
                  stackId="stacked"
                  dataKey="value"
                  fill="url(#horizontalGradient)"
                />
                <Bar stackId="stacked" dataKey="total" fill="#ffffff" />
              </BarChart>
            </ResponsiveContainer>
          </Fragment>
        );
      })
    );
  };

  return (
    <div className="row border-between-metrics-solid">
      {data.map((section, i) => (
        <section className="col-12 col-md-3" key={i}>
          {renderHeader(section)}
          {renderCharts(section, section.type)}
        </section>
      ))}
    </div>
  );
};
export default AttributionSummary;
